import React from "react";
import PolicyPage from "../../components/PolicyPage";
import useCmsData from "../../hook/useCmsData";

const PrivacyPolicy = () => {
  const { cmsData } = useCmsData();
  const policy = cmsData.find((item) => item?.title === "Privacy Policy");

  return <PolicyPage title={policy?.title} content={policy?.content} />;
};

export default PrivacyPolicy;
